module.exports = __webpack_public_path__ + "img/头像框2.963012a8.png";